// extracted by mini-css-extract-plugin
module.exports = {"installed":"styles_installed__JkVn4","crashed":"styles_crashed__Bj_iC","reason":"styles_reason__qNT9S","wrapper":"styles_wrapper__s0RMe"};